/**
 * Contains menu data information
 * @property {Backend} backend
 */
import { MenuTracker } from './MenuTracker';

export class MenuData {
  /**
   * Create a MenuData instance
   * @param {Backend} backend
   */
  constructor(backend) {
    this.backend = backend;
  }

  /**
   * retrieve the menu items
   * @returns {IMenuItem[]}
   */
  menuItems() {
    return this.backend.menu.items;
  }

  /**
   * Creates a menu tracker for the current session
   * @returns {MenuTracker}
   */
  createMenuTracker() {
    return new MenuTracker(this.backend.menu);
  }
  /**
   * retrieve the profile information
   * @returns {MenuProfileData}
   */
  profileData() {
    return {
      backend: this.backend,
      // displayName: this.backend.sessionInfo.customer.displayName,
      displayName: this.backend.deviceProfile.profile.name,
      avatarURL: `${this.backend.deviceProfile.image}?form=avatar-1`,
      isAuthorized: true,
    };
  }
}
